import React, { IframeHTMLAttributes } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './VideoModal.less';

type VideoModalPropTypes = {
  className?: string;
  videoId: string;
  title: string;
  iFrameOptions: IframeHTMLAttributes<HTMLIFrameElement>;
  videoHost: 'YOUTUBE' | 'VIMEO';
};

export const VideoModal = (props: VideoModalPropTypes): JSX.Element => {
  const { videoId, title, className, iFrameOptions, videoHost } = props;
  const src =
    videoHost === 'VIMEO'
      ? `https://player.vimeo.com/video/${videoId}?autoplay=true`
      : `https://www.youtube.com/embed/${videoId}?rel=0&autoplay=true`;

  const classes = cx('zola-ui', className);

  return (
    <div id="video-modal" className={classes}>
      <div className="modal-header">
        {title ? <h2 className="h3 modal-title">{title}</h2> : null}
      </div>
      <div className="modal-body">
        <div className="embed-responsive embed-responsive-16by9">
          <iframe title={title || 'video-iframe'} src={src} {...iFrameOptions} />
        </div>
      </div>
    </div>
  );
};

VideoModal.propTypes = {
  className: PropTypes.string,
  videoId: PropTypes.string.isRequired,
  title: PropTypes.string,
  iFrameOptions: PropTypes.shape({}),
  videoHost: PropTypes.oneOf(['YOUTUBE', 'VIMEO']),
};

VideoModal.defaultProps = {
  iFrameOptions: {
    allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
    allowFullScreen: true,
    frameBorder: '0',
    className: 'embed-responsive-item',
  },
  videoHost: 'YOUTUBE',
};

export default VideoModal;
